export default __webpack_public_path__ + "static/media/white-circle-shadow.e68ea19c.svg";